// #BACE60 -> #2B96D8
export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#FF0000',
    light: '#d3eef9',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#020202',
    contrastText: '#0A5285',
    light: '#D9EDF7',
  },
  text: {
    primary: '#0E2E3B',
    secondary: '#273645',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: 'linear-gradient(113deg, #040504 -11.86%, #636563 125.27%)',
    paper: '#FFF',
    default: '#FFF',
    header: '#0D0D0D',
    footer: '#F7F7F7',
    level2: '#5D6D93',
    level1: '#4E7287',
    steps: '#000000',
    tableHead: '#020202',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#020202',
    secondary: 'rgb(240,243,243)',
    light: '#F7F7F7',
    secondaryLight: '#FBF7F5',
  },
  verticalBar: {
    used: '#FF0000',
    unused: '#ffe5e5',
    unlimited: '#C0C0C0',
  },
};
